import type { MouseEvent } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { BorderCard } from "./styledComponents";

interface ISeeMoreCardProps {
    width: number;
    height: number;
    onClick: () => void;
    dataAutomation?: string;
}

export const SeeMoreCard = ({ width, height, onClick, dataAutomation = "see-more-card" }: ISeeMoreCardProps) => {
    const { translate } = useTranslate();

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        onClick();
    };

    return (
        <BorderCard
            data-automation={dataAutomation}
            onClick={handleClick}
            style={{ width, height }}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                width="100%"
                height="100%"
            >
                <Button
                    type="flat"
                    dataAutomation={`${dataAutomation}-button`}
                >
                    {translate("activation.alerts.cards.ads.see-more")}
                </Button>
            </Flex>
        </BorderCard>
    );
};
